module.exports = __webpack_public_path__ + "static/img/about-logo.4d3cc4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/about-logo.png
// module id = aIKQ
// module chunks = 1